export enum ApiType {
  Http = 'http',
  WebSocket = 'webSocket',
  Socket = 'socket',
  Dubbo = 'dubbo',
  DefaultCase = 'defaultCase',
  SocketIO = 'socket-io',
  Webhook = 'webhook',
  Callback = 'callback',
}

export type IApiTypeServerType =
  | ApiType.Http
  | ApiType.WebSocket
  | ApiType.Socket
  | ApiType.Dubbo
  | ApiType.DefaultCase
  | ApiType.SocketIO
  | ApiType.Webhook;
